import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import {
  formattedRate,
  ServiceRecordLeave,
} from "../../../../components/common/Converter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";

class SalaryFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.showSuccess("Successfully Saved!");
      return;
    }
    try {
      this.view.submitting();
      await this.save();
      this.view.submissionSuccess();
      this.showSuccess("Successfully Saved!");
    } catch (error) {
      this.view.showError(error);
    }
  }

  async save() {
    const collection = this.view.getCollectionName();

    if (this.object.id) {
      this.change.id = this.object.id;
      const positionTitle = await findObjectUseCase().execute(
        "position_titles",
        { where: { "salaryPointer.id": this.object.id }, keys: ["id"] }
      );
      if (positionTitle.length > 0) {
        const employees = await Promise.all(
          positionTitle.map(async (item) => {
            return await findObjectUseCase().execute("employees", {
              where: { "position.id": item.id },
              includes: ["position"],
              keys: [
                "position",
                "email",
                "employmentStatus",
                "office",
                "region",
                "salaryGrade",
              ],
            });
          })
        );
        // console.log("POSITION: ", employees);
        if (employees.lengtht === 0) {
          return;
        }
        for (const emp of employees) {
          // console.log("EMP: ", emp);
          emp.forEach((item) => {
            // console.log("ITEM: ", item);
            this.insertServiceRecord(item);
          });
        }
      }
    } else {
      this.change.acl = this.view.getAcl();
    }
    // return;
    try {

      const salaryGrade =
        this.change?.["Salary Grade"] ?? this.object?.["Salary Grade"];
      const step = this.change?.Step ?? this.object?.Step;

      if (salaryGrade && step) {
        this.change.salaryCode = `SG${salaryGrade}-${step}`;
      }

      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }

  async insertServiceRecord(updateEmployee) {
    const effectivity = updateEmployee?.effectivityDate
      ? new Date(updateEmployee?.effectivityDate)
      : new Date();
    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: updateEmployee?.id, to: { $exists: false } },
    });

    const dateFrom = serviceRec[0]?.from
      ? new Date(serviceRec[0]?.from)
      : new Date();
    dateFrom.setDate(dateFrom.getDate() - 1);
    const leaveReq = await findObjectUseCase().execute("leave_request", {
      where: {
        employee: { id: updateEmployee.id },
        stats: { $ne: "For Processing" },
        $or: [
          { startdate: { $gte: dateFrom, $lte: effectivity } },
          { enddate: { $gte: dateFrom, $lte: effectivity } },
        ],
      },
    });

    const salary = `${this.object.name} (₱ ${formattedRate(
      this.object["Monthly Rate"]
    )} per month)`.replace(
      /₱\s?([\d,]+\.\d{2})/,
      (_, num) => `₱ ${(parseFloat(num.replace(/,/g, "")) * 12).toFixed(2)}`
    );

    const serviceLog = {
      email: updateEmployee?.email,
      empID: updateEmployee?.id,
      from: effectivity,
      employee: { id: updateEmployee.id },
      designation: updateEmployee?.position?.position_title,
      status: updateEmployee?.employmentType?.name || "",
      salary: salary,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      cause: "Salary Adjustment",
    };

    if (serviceRec.length > 0) {
      let leaveStatus = [];
      for (const leave of leaveReq) {
        // Extract and abbreviate the selectedType
        const selectedType = leave.selectedType;
        const abbreviation = selectedType
          .split(" ") // Split the string into an array of words
          .map((word) => word.charAt(0)) // Take the first letter of each word
          .join(""); // Join them back together

        // Format the startDate and endDate
        leaveStatus.push(
          ServiceRecordLeave(
            abbreviation,
            new Date(leave?.startdate),
            new Date(leave?.enddate)
          )
        ); // Add to the result array
      }
      serviceRec[0].to = serviceLog?.from;
      serviceRec[0].leave = leaveStatus;
      serviceRec[0].status = serviceLog?.status;
      console.log("serviceLog: ", serviceRec[0]);

      await upsertUseCase().execute("service_record", serviceRec[0]);
    }
    console.log("SERIVE: ", serviceLog);
    await upsertUseCase().execute("service_record", serviceLog);
  }
}

export default SalaryFormPresenter;
